import { createGuid, hasValue, hasValueAndNotEmpty } from "@itk/typescript-utils";
import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store";
import { fileDownloadActions } from "./file-download-store";

export const useFileDownload = (fileId: string | undefined, preview = false) => {
  const instanceId = useMemo(() => createGuid(), []);
  const selector = useCallback((state: RootState) => state.hooksReducer.fileDownloadReducer, []);
  const dispatch = useDispatch();
  const state = useSelector(selector);

  const loading = useMemo(() => state.instances.find(i => i.instanceId === instanceId)?.loading, [state]);

  useEffect(() => {
    dispatch(fileDownloadActions.initFileDownloadInstance(instanceId));
  }, []);

  const fileInfo = useMemo(() => (hasValue(loading) && loading.loading === "has-loaded" ? loading.data : undefined), [loading]);

  useEffect(() => {
    if (hasValueAndNotEmpty(fileId)) {
      dispatch(fileDownloadActions.getFileDownloadRequest(instanceId, fileId, preview));

      return () => {
        dispatch(fileDownloadActions.resetFileDownload(instanceId));
      };
    }
  }, [fileId, instanceId, preview]);

  useEffect(() => {
    return () => {
      if (hasValue(fileInfo)) {
        URL.revokeObjectURL(fileInfo.url);
      }
    };
  }, [fileInfo]);

  return { fileInfo };
};
